var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommunityIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.42521 7.72413C4.42521 5.10363 6.52944 2.99976 9.15008 2.99976C11.7707 2.99976 13.8749 5.10363 13.8749 7.72413C13.8749 10.3455 11.7708 12.4495 9.15008 12.4495C6.52935 12.4495 4.42521 10.3455 4.42521 7.72413ZM2.33643 18.7378C2.33643 16.1946 4.39813 14.1329 6.94138 14.1329H11.1005C13.6438 14.1329 15.7055 16.1946 15.7055 18.7378C15.7055 19.9873 14.6926 21.0003 13.443 21.0003H4.59887C3.34935 21.0003 2.33643 19.9873 2.33643 18.7378ZM15.3923 11.7239C14.8618 11.7239 14.6761 11.0882 14.9603 10.6401C15.4917 9.8023 15.7988 8.80629 15.7988 7.73478C15.7988 6.61072 15.4606 5.56968 14.8798 4.70724C14.4376 4.05044 14.6005 3.07171 15.3923 3.07171C17.7918 3.07171 19.7185 4.99803 19.7185 7.39737C19.7185 9.79752 17.7919 11.7239 15.3923 11.7239ZM17.5553 18.3949C17.5553 19.5293 18.4749 20.4489 19.6093 20.4489C20.7437 20.4489 21.6633 19.5293 21.6633 18.3949V18.3226C21.6633 15.9323 19.6016 13.9946 17.0583 13.9946C16.607 13.9946 16.3774 14.6882 16.6605 15.0397C17.2234 15.7387 17.5553 16.5978 17.5553 17.5266V18.3949Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunityIcon);
export default __webpack_public_path__ + "static/media/community-icon.c94261f9e0409a879bafff12efed7095.svg";
export { ForwardRef as ReactComponent };